// extracted by mini-css-extract-plugin
export default {"answer":"answer___fef9821d10ad4013","field":"field___b43b922907c53e9d","name":"name___b9e740bb4eea7070","text":"text___da543b4055ab3db3"};